import React, {useState} from 'react';
import {Tabs} from 'antd';
import TrophyChallenge from './TrophyChallenge';
import TrophyChallengeGroupManager from './TrophyChallengeGroupManager';
import TrophyChallengeMissionManager from './TrophyChallengeMissionManager';

const TrophyChallengeIndex = () => {
    const [activeKey, setActiveKey] = useState('challenge');

    const items = [
        {
            key: 'challenge',
            label: '트로피 챌린지',
            children: <TrophyChallenge/>,
        },
        {
            key: 'group',
            label: '챌린지 그룹 관리',
            children: <TrophyChallengeGroupManager/>,
        },
        {
            key: 'mission',
            label: '챌린지 미션 관리',
            children: <TrophyChallengeMissionManager/>,
        },
    ];

    return (
        <Tabs
            activeKey={activeKey}
            onChange={setActiveKey}
            items={items}
        />
    );
};

export default TrophyChallengeIndex;
